export const categories = [
  "All", "Smartphones", "Laptops", "Audio", "Wearables", "Cameras", "Gaming", "Accessories"
];

export const products = [
  {
    id: 1, name: "ProMax Ultra 15", brand: "ApexTech",
    category: "Smartphones", price: 1199, originalPrice: 1399,
    rating: 4.8, reviews: 2341, stock: 15,
    badge: "Best Seller",
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=500&q=80",
    description: "The most powerful smartphone ever made. 6.7\" OLED display, 200MP camera system, and all-day battery life.",
    specs: { Display: "6.7\" OLED 120Hz", Processor: "Apex A17 Pro", RAM: "12GB", Storage: "256GB", Battery: "5000mAh", Camera: "200MP Triple" },
    colors: ["#1a1a1a", "#e8e0d5", "#2d4a8a"],
  },
  {
    id: 2, name: "NovaPad X Pro", brand: "NovaTech",
    category: "Laptops", price: 1599, originalPrice: 1799,
    rating: 4.7, reviews: 1876, stock: 8,
    badge: "New",
    image: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=500&q=80",
    description: "Ultra-thin laptop with 14-hour battery, stunning 4K display and professional-grade performance.",
    specs: { Display: "14\" 4K OLED", Processor: "Intel Core Ultra 9", RAM: "32GB DDR5", Storage: "1TB NVMe", Battery: "14hrs", GPU: "Intel Arc" },
    colors: ["#c0c0c0", "#1a1a1a"],
  },
  {
    id: 3, name: "SoundPro ANC Elite", brand: "AudioMax",
    category: "Audio", price: 349, originalPrice: 449,
    rating: 4.9, reviews: 5621, stock: 42,
    badge: "Top Rated",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=500&q=80",
    description: "Industry-leading noise cancellation with 30-hour battery life and premium Hi-Fi audio.",
    specs: { Type: "Over-ear ANC", Battery: "30hrs", Drivers: "40mm Dynamic", Frequency: "20Hz–20kHz", Connection: "Bluetooth 5.3", Weight: "250g" },
    colors: ["#1a1a1a", "#f5f5f0", "#8b7355"],
  },
  {
    id: 4, name: "FitPro Watch Ultra", brand: "FitTech",
    category: "Wearables", price: 499, originalPrice: 599,
    rating: 4.6, reviews: 3210, stock: 25,
    badge: "Sale",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500&q=80",
    description: "Advanced health monitoring, GPS tracking, and 18-day battery in a premium titanium case.",
    specs: { Display: "2.0\" AMOLED", Battery: "18 days", GPS: "Dual-band", Health: "ECG, SpO2, Stress", Water: "100m WR", Material: "Titanium" },
    colors: ["#8b7355", "#1a1a1a", "#c0c0c0"],
  },
  {
    id: 5, name: "SnapPro X100", brand: "LensMaster",
    category: "Cameras", price: 2299, originalPrice: 2599,
    rating: 4.9, reviews: 987, stock: 5,
    badge: "Pro",
    image: "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=500&q=80",
    description: "Full-frame mirrorless camera with 61MP sensor, 8K video recording, and professional AF system.",
    specs: { Sensor: "61MP Full-frame", Video: "8K 30fps", ISO: "100-51200", AF: "693-point PDAF", Shutter: "1/8000s", Weight: "650g" },
    colors: ["#1a1a1a"],
  },
  {
    id: 6, name: "GamePad Pro X", brand: "PlayTech",
    category: "Gaming", price: 699, originalPrice: 799,
    rating: 4.7, reviews: 4523, stock: 18,
    badge: "Hot",
    image: "https://images.unsplash.com/photo-1486401899868-0e435ed85128?w=500&q=80",
    description: "Next-gen gaming console with 8K gaming, ray tracing, and 2TB ultra-fast SSD storage.",
    specs: { CPU: "Custom Zen 4", GPU: "RDNA 4", RAM: "24GB GDDR6", Storage: "2TB NVMe", Resolution: "Up to 8K", FPS: "Up to 120fps" },
    colors: ["#1a1a1a", "#f5f5f0"],
  },
  {
    id: 7, name: "BudsPro ANC+", brand: "AudioMax",
    category: "Audio", price: 249, originalPrice: 299,
    rating: 4.5, reviews: 7832, stock: 60,
    badge: null,
    image: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=500&q=80",
    description: "True wireless earbuds with adaptive ANC, spatial audio, and 36-hour total battery life.",
    specs: { Type: "True Wireless", Battery: "9+27hrs", ANC: "Adaptive", Driver: "11mm Dynamic", Water: "IPX5", Connection: "Bluetooth 5.3" },
    colors: ["#1a1a1a", "#f5f5f0", "#2d4a8a"],
  },
  {
    id: 8, name: "TabMax Pro 12", brand: "ApexTech",
    category: "Laptops", price: 899, originalPrice: 999,
    rating: 4.6, reviews: 1543, stock: 12,
    badge: "Sale",
    image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=500&q=80",
    description: "The ultimate tablet for professionals. 12.9\" Liquid Retina XDR display with M3 chip performance.",
    specs: { Display: "12.9\" Liquid Retina XDR", Chip: "M3", RAM: "16GB", Storage: "512GB", Battery: "10hrs", Pencil: "Compatible" },
    colors: ["#c0c0c0", "#1a1a1a", "#2d4a8a"],
  },
  {
    id: 9, name: "ChargeMax 200W Hub", brand: "PowerTech",
    category: "Accessories", price: 89, originalPrice: 119,
    rating: 4.4, reviews: 2190, stock: 100,
    badge: null,
    image: "https://images.unsplash.com/photo-1625895197185-efcec01cffe0?w=500&q=80",
    description: "7-in-1 USB-C hub with 200W total output, 4K HDMI, and ultra-fast data transfer.",
    specs: { Power: "200W Total", Ports: "7-in-1", HDMI: "4K 60Hz", USB: "USB-C 3.2 + USB-A", SD: "SD/MicroSD", Speed: "10Gbps" },
    colors: ["#c0c0c0"],
  },
  {
    id: 10, name: "VisionPro VR Headset", brand: "VRTech",
    category: "Gaming", price: 3499, originalPrice: 3999,
    rating: 4.8, reviews: 654, stock: 3,
    badge: "Limited",
    image: "https://images.unsplash.com/photo-1622979135225-d2ba269cf1ac?w=500&q=80",
    description: "Revolutionary spatial computing device with micro-OLED displays and 3D audio for immersive experiences.",
    specs: { Display: "Micro-OLED 4K per eye", Processor: "M3 + R1 chip", RAM: "16GB", Storage: "512GB", Battery: "2hrs + power", Tracking: "Eye + Hand + Head" },
    colors: ["#f5f5f0"],
  },
  {
    id: 11, name: "DeskCam 4K Pro", brand: "VisionTech",
    category: "Accessories", price: 199, originalPrice: 249,
    rating: 4.5, reviews: 3421, stock: 30,
    badge: null,
    image: "https://images.unsplash.com/photo-1587826080692-f439cd0b70da?w=500&q=80",
    description: "Professional 4K webcam with AI framing, noise-cancelling mic, and HDR for crystal-clear video calls.",
    specs: { Resolution: "4K 30fps / 1080p 60fps", FOV: "90°", Mic: "Dual Noise-cancel", HDR: "Yes", AI: "Auto-framing", Connection: "USB-C" },
    colors: ["#1a1a1a"],
  },
  {
    id: 12, name: "MechKeys Pro 75%", brand: "KeyMaster",
    category: "Accessories", price: 159, originalPrice: 199,
    rating: 4.7, reviews: 5012, stock: 45,
    badge: "Popular",
    image: "https://images.unsplash.com/photo-1618384887929-16ec33fab9ef?w=500&q=80",
    description: "Compact 75% mechanical keyboard with hot-swappable switches, per-key RGB, and aluminum frame.",
    specs: { Layout: "75% Compact", Switches: "Hot-swappable", RGB: "Per-key RGB", Frame: "CNC Aluminum", Connection: "USB-C + Wireless", Battery: "4000mAh" },
    colors: ["#f5f5f0", "#1a1a1a", "#2d4a8a"],
  },
];
